export default {
  formDialog: {
    height: '100%',
    width: '100%',
  },
  step: { padding: '1rem 0' },
  loadingButtonProgress: { position: 'absolute' },
};
